import Section from '~/components/Common/Section'
import ChangeDrawer from '~/components/Drawers/Change/ChangeDrawer'

import { ChangeScheduleCalendar } from './components/Calendar'
import { ChangeFiltersProvider } from './context/ChangeFilter/provider'

const ChangeSchedules = () => {
  return (
    <ChangeFiltersProvider>
      <Section>
        <ChangeScheduleCalendar />
      </Section>

      <ChangeDrawer />
    </ChangeFiltersProvider>
  )
}

export default ChangeSchedules
